var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_344_1305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 40C3.625 40 2.45 39.5 1.475 38.525C0.5 37.55 0 36.375 0 35V5C0 3.625 0.5 2.45 1.475 1.475C2.45 0.5 3.625 0 5 0H45C46.375 0 47.55 0.5 48.525 1.475C49.5 2.45 50 3.625 50 5V35C50 36.375 49.5 37.55 48.525 38.525C47.55 39.5 46.375 40 45 40H5ZM5 35H45V5H5V35ZM35.825 34.3L39.325 30.8L33.25 24.725C33.825 23.8 34.275 22.85 34.575 21.85C34.875 20.85 35.025 19.8 35.025 18.725C35.025 15.6 33.925 12.95 31.75 10.75C29.575 8.55 26.9 7.475 23.775 7.475C20.65 7.475 18 8.575 15.8 10.75C13.6 12.925 12.525 15.6 12.525 18.725C12.525 21.85 13.625 24.5 15.8 26.7C17.975 28.9 20.65 29.975 23.775 29.975C24.85 29.975 25.9 29.825 26.9 29.525C27.9 29.225 28.85 28.8 29.775 28.2L35.85 34.275L35.825 34.3ZM23.75 24.975C22 24.975 20.525 24.375 19.3 23.15C18.075 21.925 17.475 20.45 17.475 18.7C17.475 16.95 18.075 15.475 19.3 14.25C20.525 13.025 22 12.425 23.75 12.425C25.5 12.425 26.975 13.025 28.2 14.25C29.4 15.45 30.025 16.95 30.025 18.7C30.025 20.45 29.425 21.925 28.2 23.15C27 24.35 25.5 24.975 23.75 24.975Z",
    fill: "#142862"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_344_1305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchTicketIcon);
export default __webpack_public_path__ + "static/media/search_ticket_icon.f53f60f887426f53036301e5329a398e.svg";
export { ForwardRef as ReactComponent };